export default __webpack_public_path__ + "static/media/contact.44f3fe87.png";